import { Component, inject, OnInit, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take, tap } from 'rxjs';
import { CoreModule, FormComponent, OffersType, PERIODS, PRODUCT_TYPES_ACCOMMODATION_FOR_FILTERS, PRODUCT_TYPES_DAYTRIP, TARGET_AUDIENCES } from '@toevla-webapplications/core';
import { OffersFilters } from '../../../../store/offers/offers.model';
import { IvvaStore } from '../../../../store/store.model';
import { Location } from '../../../../services/locations/location.model';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import OFFERS_ACTIONS from '../../../../store/offers/offers.actions';
import { FormBuilder } from '@angular/forms';
import { Offer } from '../../../../services/offers/offer.model';
import { LocationType } from '../../../../services/locations/location-type.enum';
import { OffersService } from '../../../../services/offers/offers.service';

@Component({
    selector: 'ivva-main-filter',
    templateUrl: './main-filter.component.html',
    styleUrls: ['./main-filter.component.scss'],
    imports: [AsyncPipe, TranslateModule, CoreModule]
})
export class MainFilterComponent extends FormComponent implements OnInit {
	filters: Partial<OffersFilters>;
	locations$: Observable<Location[]>;
	type$: Observable<OffersType>;

	offersAsOptions = signal<Partial<Offer>[]>([]);

	readonly LocationType = LocationType;
	readonly OffersType = OffersType;
	readonly PERIODS = PERIODS;
	readonly PRODUCT_TYPES_ACCOMMODATION = PRODUCT_TYPES_ACCOMMODATION_FOR_FILTERS;
	readonly PRODUCT_TYPES_DAYTRIP = PRODUCT_TYPES_DAYTRIP;
	readonly Offer = Offer;
	readonly TARGET_AUDIENCES = TARGET_AUDIENCES;

	private readonly fb = inject(FormBuilder);
	private readonly offersService = inject(OffersService);
	private readonly store = inject(Store<IvvaStore>);

	ngOnInit() {
		this.locations$ = this.store.select('offers', 'locations');
		this.type$ = this.store.select('offers', 'type').pipe(tap(() => this.initFilter()));
	}

	applyFilters() {
		this.store.next(OFFERS_ACTIONS.setFilters({ filters: this.form.value }));
	}

	searchLocationName(name: string) {
		if (name?.length >= 3) {
			this.offersService.getOffersByName(name).subscribe((offers) => {
				this.offersAsOptions.set(offers);
			});
		} else {
			this.offersAsOptions.set([]);
		}
	}

	private initFilter() {
		this.offersAsOptions.set([]);

		this.store
			.select('offers')
			.pipe(take(1))
			.subscribe(({ type, filters }) => {
				if (type === OffersType.ORGANIZED_HOLIDAY) {
					this.form = this.fb.group({
						targetAudiences: [filters.targetAudiences],
						periods: [filters.periods],
					});
				} else {
					this.form = this.fb.group({
						location: [filters.location],
						productTypes: [filters.productTypes],
					});
				}
			});
	}
}
